/* ============================================
   KUMOO Product Card — Size Selection JS
   ============================================
   
   Cách dùng:
   1. Copy vào Assets/kumoo-card.js
   2. Thêm <script src="{{ 'kumoo-card.js' | asset_url }}" defer></script>
      vào layout/theme.liquid trước </body>
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  
  // Size button click → update variant ID + highlight
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('.kumoo-card__size');
    if (!sizeBtn || sizeBtn.disabled) return;
    
    var card = sizeBtn.closest('.kumoo-card');
    if (!card) return;
    
    // Remove active from siblings
    card.querySelectorAll('.kumoo-card__size').forEach(function(btn) {
      btn.classList.remove('active');
    });
    sizeBtn.classList.add('active');
    
    // Find matching variant
    var productId = card.dataset.productId;
    var selectedSize = sizeBtn.dataset.size;
    var activeColor = card.querySelector('.kumoo-card__swatch.active');
    var selectedColor = activeColor ? activeColor.dataset.color : null;
    
    updateVariantId(card, productId, selectedSize, selectedColor);
  });
  
  // Color swatch click → update active + variant
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.kumoo-card__swatch');
    if (!swatch) return;
    
    var card = swatch.closest('.kumoo-card');
    if (!card) return;
    
    card.querySelectorAll('.kumoo-card__swatch').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
    
    var productId = card.dataset.productId;
    var selectedColor = swatch.dataset.color;
    var activeSize = card.querySelector('.kumoo-card__size.active');
    var selectedSize = activeSize ? activeSize.dataset.size : null;
    
    updateVariantId(card, productId, selectedSize, selectedColor);
  });
  
  // ATC form → AJAX submit (không redirect)
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.kumoo-card__atc-form');
    if (!form) return;
    
    e.preventDefault();
    
    var btn = form.querySelector('.kumoo-card__atc-btn');
    var originalText = btn.textContent;
    btn.textContent = 'ĐANG THÊM...';
    btn.disabled = true;
    
    var variantId = form.querySelector('.kumoo-card__variant-id').value;
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      btn.textContent = 'ĐÃ THÊM ✓';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
      
      // Update cart count nếu theme có
      updateCartCount();
    })
    .catch(function(err) {
      btn.textContent = 'LỖI — THỬ LẠI';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    });
  });
  
  // Helper: tìm variant ID từ color + size
  function updateVariantId(card, productId, selectedSize, selectedColor) {
    if (!productId) return;
    
    // Fetch product JSON từ Shopify
    fetch('/products/' + getProductHandle(card) + '.js')
      .then(function(res) { return res.json(); })
      .then(function(product) {
        var match = null;
        
        product.variants.forEach(function(v) {
          var options = v.options || [];
          var colorMatch = !selectedColor || options.some(function(o) {
            return o.toLowerCase() === selectedColor.toLowerCase();
          });
          var sizeMatch = !selectedSize || options.some(function(o) {
            return o === selectedSize;
          });
          
          if (colorMatch && sizeMatch) {
            match = v;
          }
        });
        
        if (match) {
          var input = card.querySelector('.kumoo-card__variant-id');
          if (input) input.value = match.id;
        }
      })
      .catch(function() {});
  }
  
  // Helper: lấy product handle từ link trong card
  function getProductHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var parts = link.href.split('/products/');
    return parts[1] ? parts[1].split('?')[0] : '';
  }
  
  // Helper: cập nhật cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var counters = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
        counters.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function() {});
  }
});